import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import {
  createLiveStreamRequest,
  type LiveStreamRequestCreated,
} from 'services/liveStreamRequests';

const useCreateLiveStreamRequest = (): UseMutationResult<
  LiveStreamRequestCreated,
  unknown,
  string
> =>
  useMutation({
    mutationFn: (offeringId: string) => createLiveStreamRequest(offeringId),
    retry: false,
  });

export default useCreateLiveStreamRequest;
